// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-m_gV","galleryItem_borderTopRadius":"c-m_gW","galleryItem__image":"c-m_gX","galleryItem__image_withBlur":"c-m_gY"};